import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Home.module.css';
import SpeakerModal from '../components/SpeakerModal/SpeakerModal';

const SPEAKERS = [
  {
    id: 1,
    nombre: 'Dr. Roberto Benavides',
    titulo: 'Medicina interna - Neumología',
    especialidad: '',
    bio: 'Clínica Cardio VID. Hospital Pablo Tobón Uribe. Unidad de Investigaciones SURA. Profesor Universidad de Antioquia-Universidad CES.',
    photo: `${process.env.PUBLIC_URL}/roberto-benavides.png`,
  },
  {
    id: 2,
    nombre: 'Dr. Andrés Chavarriaga',
    titulo: 'Reumatólogo Clínica CES, Clipso.',
    especialidad: '',
    bio: '',
    photo: `${process.env.PUBLIC_URL}/andres-chavarriaga.png`,
  },
  {
    id: 3,
    nombre: 'Dra. Cristiane Kayser',
    titulo: 'Reumatóloga, Universidad Federal de São Paulo, Brasil.',
    especialidad: '',
    bio: '',
    photo: `${process.env.PUBLIC_URL}/cristiane-kayser.png`,
  },
  {
    id: 4,
    nombre: 'Dra. Emily Rincón',
    titulo: 'Médica Internista - Neumóloga.',
    especialidad: 'Máster en Enfermedades Autoinmunes Sistémicas.',
    bio: 'Máster en Hipertensión Pulmonar. Máster en Enfermedades Pulmonares Intersticiales. Líder Clínica de EPID - Fundación Neumológica Colombiana.',
    photo: `${process.env.PUBLIC_URL}/emily-rincon.png`,
  },
  {
    id: 5,
    nombre: 'Dr. Martín Fernández',
    titulo: 'Médico Especialista en Neumonología.',
    especialidad: 'Sección Enfermedades Pulmonares Intersticiales Hospital de Rehabilitación Respiratoria María Ferrer.',
    bio: 'Ex director del departamento de enf. intersticiales de la Asociación Argentina de Medicina Respiratoria. Director de posgrado en Neumonología. Universidad de Buenos Aires.',
    photo: `${process.env.PUBLIC_URL}/martin-fernandez.png`,
  },
  {
    id: 6,
    nombre: 'Dr. Rubén Contreras',
    titulo: 'Médico Internista - Neumólogo',
    especialidad: 'Especialista en Docencia e Investigación de la Universidad El Bosque. Bogotá.',
    bio: '',
    photo: `${process.env.PUBLIC_URL}/speaker6.png`,
  },
  {
    id: 7,
    nombre: 'Dr. Jorge Alberto Carrillo Bayona',
    titulo: 'Profesor Universidad Nacional de Colombia.',
    especialidad: 'Radiólogo.',
    bio: 'Hospital Universitario Mayor Mederi. RIMAB.',
    photo: `${process.env.PUBLIC_URL}/jorge-carrillo-bayona.png`,
  },
];

export default function Home() {
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const location = useLocation();

  const refreshUsuario = useCallback(() => {
    try {
      const stored = localStorage.getItem('usuario');
      setUsuario(stored ? JSON.parse(stored) : null);
    } catch {
      setUsuario(null);
    }
  }, []);

  useEffect(() => {
    refreshUsuario();
  }, [location.pathname, refreshUsuario]);

  useEffect(() => {
    const handleAuthChange = () => refreshUsuario();
    window.addEventListener('user-logout', handleAuthChange);
    window.addEventListener('user-login', handleAuthChange);
    return () => {
      window.removeEventListener('user-logout', handleAuthChange);
      window.removeEventListener('user-login', handleAuthChange);
    };
  }, [refreshUsuario]);

  return (
    <div className={styles.home}>
      {/* Hero: logo + título + slogan */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.logoWrapper}>
            <div className={styles.logoCircle}>
              <img
                src={`${process.env.PUBLIC_URL}/logo.gif`}
                alt="4to MasterClass EPI - Juntos Transformando Vidas"
                className={styles.logoImg}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Frase: Más de una década de evidencia, más de un siglo de innovación */}
      <section className={styles.info}>
        <div className={styles.infoContent}>
          <img
            src={`${process.env.PUBLIC_URL}/frase.gif`}
            alt="Más de una década de evidencia, más de un siglo de innovación"
            className={styles.fraseImg}
          />
        </div>
      </section>

      {/* CTA: frase + botones */}
      <section className={styles.cta}>
        <p className={usuario ? styles.ctaTextLogged : styles.ctaText}>
          {usuario ? 'Explora la ruta de la innovación' : 'Sea parte del legado'}
        </p>
        <div className={styles.ctaButtons}>
          {usuario ? (
            <>
              <Link to="/agenda" className={styles.botonAgenda}>
                Agenda
                <span className={styles.botonIcon} aria-hidden>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </span>
              </Link>
              <Link to="/informacion-logistica" className={styles.botonInfoLogistica}>
                Información logística
                <span className={styles.botonIcon} aria-hidden>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="16" x2="12" y2="12" />
                    <line x1="12" y1="8" x2="12.01" y2="8" />
                  </svg>
                </span>
              </Link>
              <Link to="/preguntas" className={styles.botonPreguntas}>
                Preguntas
                <span className={styles.botonIcon} aria-hidden>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                </span>
              </Link>
              {usuario?.es_staff && (
                <Link to="/admin/preguntas" className={styles.botonVerPreguntas}>
                  Ver preguntas
                  <span className={styles.botonIcon} aria-hidden>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </span>
                </Link>
              )}
            </>
          ) : (
            <>
              <Link to="/about" className={styles.botonRegistro}>
                Registro <span className={styles.botonArrow}>&gt;&gt;</span>
              </Link>
              <a href="#speakers" className={styles.botonSpeakers}>
                Nuestros Speakers
              </a>
            </>
          )}
        </div>
      </section>

      {/* Nuestros Speakers */}
      <section className={styles.speakers} id="speakers">
        <div className={styles.speakersGridWrapper}>
        <div className={styles.speakersGrid}>
          <img
            src={`${process.env.PUBLIC_URL}/mariposa.gif`}
            alt=""
            className={styles.butterflyDecor}
            aria-hidden
          />
          {SPEAKERS.map((speaker) => (
            <div
              key={speaker.id}
              className={styles.speakerHex}
              role="button"
              tabIndex={0}
              onClick={() => setSelectedSpeaker(speaker)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedSpeaker(speaker);
                }
              }}
              aria-label={`Ver información de ${speaker.nombre}`}
            >
              <div
                className={styles.speakerPhoto}
                style={
                  speaker.photo
                    ? {
                        backgroundImage: `url(${speaker.photo})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                      }
                    : undefined
                }
              />
            </div>
          ))}
        </div>
        </div>
      </section>

      <SpeakerModal
        speaker={selectedSpeaker}
        onClose={() => setSelectedSpeaker(null)}
      />
    </div>
  );
}
